module.exports = "/packs/media/images/budget4-b041a49052bc7b7609a4430544b68cd9.jpg";